var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "css-grid sales-report__stats" },
    [
      _c("StatsRevenuePerEmployee"),
      _vm._v(" "),
      _c("StatsUnitsPerEmployee"),
      _vm._v(" "),
      _c("StatsAsp"),
      _vm._v(" "),
      _c("div", { staticClass: "sales-report__stats-disclaimer" }, [
        _vm._v(
          "* National Averages calculated from Fuel Members across the United States"
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }